<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path xmlns="http://www.w3.org/2000/svg" d="M0 5.33333C0 4.15513 0.895431 3.2 2 3.2C3.10457 3.2 4 4.15513 4 5.33333V13.8667C4 15.0449 3.10457 16 2 16C0.895431 16 0 15.0449 0 13.8667V5.33333Z" fill="#80B7FF"/>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M12 2.13333C12 0.955126 12.8954 0 14 0C15.1046 0 16 0.955126 16 2.13333V13.8667C16 15.0449 15.1046 16 14 16C12.8954 16 12 15.0449 12 13.8667V2.13333Z"
      fill="#80B7FF"
    />
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M6 9.6C6 8.42179 6.89543 7.46667 8 7.46667C9.10457 7.46667 10 8.42179 10 9.6V13.8667C10 15.0449 9.10457 16 8 16C6.89543 16 6 15.0449 6 13.8667V9.6Z"
      fill="#80B7FF"
    />
  </svg>
</template>

<script>
import { colors } from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: colors.iconArinet },
  },
};
</script>
